import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/authGuard';
// import { NavbarComponent } from './sharedModule/navbar/navbar.component';
import { NotFoundComponent } from './sharedModule/not-found/not-found.component';
import { DeleteSubmissions } from './sharedModule/delete-submissions/delete-submissions.component';
import { NotAuthorizedComponent } from './sharedModule/notauthorized/not-authorized.component';
import { ReportComponent as ReportComponentv2 } from './sharedModule/report-v2/report.component';
import { ExpandViewComponent } from './sharedModule/expand-view/expand-view.component';
import { AuthSessionComponent } from './auth-session/auth-session.component';
import { PdfViewerComponent } from './sharedModule/report-v2/components/pdf-viewer/pdf-viewer.component';
const routes: Routes = [
  // Used only for  logging in in case you need  a token
  //   {
  //     path: '',
  //     loadChildren: () =>
  //        import('./authModule/authmodule.module').then(
  //           (m) => m.AuthmoduleModule
  //        ),
  //  },
  // Route for IO
  {
    path: 'submission/:id/report/v2/:token',
    component: ReportComponentv2,
    canActivate: [AuthGuard],
  },
  {
    path: 'submission/:id/report/v2/:userId/:token',
    component: ExpandViewComponent,
  },
  {
    path: 'submission/:id/report/v2',
    component: ReportComponentv2,
    canActivate: [],
  },
  {
    path: 'submission/pdf-viewer',
    component: PdfViewerComponent
  },
  //  Routes for IA
  {
    path: 'report/:clientName/:submissionId/:token',
    canActivate: [AuthGuard],
    component: ReportComponentv2
  },
  {
    path: 'report/:clientName/:submissionId',
    canActivate: [],
    component: ReportComponentv2
  },
  {
    path: 'auth/session/:sessionId',
    component: AuthSessionComponent
  },
  {
    path: 'deleted-submission',
    component: DeleteSubmissions,
  },
  {
    path: 'not-found',
    component: NotFoundComponent
  },  
  {
    path: '**',
    redirectTo: '/not-found',
    pathMatch: 'full'
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
